/** @jsxImportSource @emotion/react */
import { Button } from '@quickbit/qb-design-system';

export const IframeButton = () => {
  return (
    <div
      css={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      <Button
        css={{ width: 'fit-content !important' }}
        icon="qb"
        text={`Proceed with payment`}
        onClick={() => {
          window.open(window.location.href, '_blank');
        }}
      />
    </div>
  );
};
